import Vue from 'vue'

/**
 * Les absences d'un membre (vacances…) : ses recharges à domicile pendant ces jours ne sont pas
 * remboursées. Dates en 'YYYY-MM-DD', jours inclus.
 */
class MemberAbsenceRepository {

  // GET /api/organizations/{organizationId}/members/{memberId}/absences
  // → [{ id, from, to, note, declaredBy: person|manager, declaredByName, deletable, createdAt }]
  list(organizationId, memberId) {
    return this.fetch({ url: this.url(organizationId, memberId), method: 'get' })
  }

  // GET …/absences/setting → { applies } : le remboursement de l'organisation exclut les absences ; sinon on ne les montre pas
  setting(organizationId, memberId) {
    return this.fetch({ url: `${this.url(organizationId, memberId)}/setting`, method: 'get' })
  }

  // POST — { from, to, note? } → { id }
  create(organizationId, memberId, { from, to, note = null }) {
    return this.fetch({ url: this.url(organizationId, memberId), method: 'post', data: { from, to, note } })
  }

  // DELETE …/absences/{absenceId} → 204
  delete(organizationId, memberId, absenceId) {
    return this.fetch({ url: `${this.url(organizationId, memberId)}/${absenceId}`, method: 'delete' })
  }

  url(organizationId, memberId) {
    return `/api/organizations/${organizationId}/members/${memberId}/absences`
  }

  fetch(options) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch(options)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default new MemberAbsenceRepository()
